import { useState, useEffect, useRef } from 'react';
import ProductCard from './ProductCard';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ChevronLeftOutlinedIcon from '@material-ui/icons/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';

function HomeProduct(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const { title, langs, remove, isLocal, fridge } = props;
  const [mainL, setMainL] = useState('en-US');
  const [showp, setShowp] = useState(false);
  const theme = JSON.parse(localStorage.getItem('machine'))?.themeColor;
  const ref = useRef(null);

  const [showL, setShowL] = useState(true);
  const [showR, setShowR] = useState(true);

  let arrayClassName = (c1) => {
    let classname = 'home-page-arrow-icon ' + c1;
    if (theme?.highlight_scrollbar === 'true') classname += ' home-page-arrow-icon-highlight';
    return classname;
  };

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    } else if (mycoockie === 'zh') {
      setMainL('zh-CN');
    }
  }, []);

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  const runState = () => {
    if (ref) {
      setShowL(ref.current.scrollLeft === 0);
      setShowR(!(ref.current.scrollLeft < ref.current.scrollWidth - ref.current.clientWidth));
    }
  };

  const handleScroll = () => {
    runState();
  };

  useEffect(() => {
    runState();
  }, []);

  useEffect(() => {
    if (ref) {
      ref.current?.addEventListener('scroll', handleScroll, { passive: true });

      return () => {
        ref.current?.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  let result = JSON.parse(localStorage.getItem('bestSeller'));
  let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
  let machineID = JSON.parse(localStorage.getItem('machine'))?._id;

  symbol = symbol ? symbol : '$';
  result = result.filter((prod) => {
    if (!fridge) return prod.prodType === 'prod';
    if (fridge === '1') return prod.prodType === 'fridge1';
    else if (fridge === '2') return prod.prodType === 'fridge2';
    else if (fridge === '3') return prod.prodType === 'linkedBox';
  });
  console.log('result lockers', result);
  let bestSellerText = t(`Best Seller`);
  if (
    localStorage.getItem('ENABLE_FRIDGE') === 'TRUE' ||
    localStorage.getItem('ENABLE_LOCKER') === 'TRUE'
  ) {
    bestSellerText = t(`Machine Products`);
    const products = JSON.parse(localStorage.getItem('products'));
    if (fridge === '1') {
      bestSellerText = t(`Fridge Products`);
      result = products.filter((prod) => prod.prodType === 'fridge1');
    }
    if (fridge === '2') {
      bestSellerText = t(`Shelf Products`);
      result = products.filter((prod) => prod.prodType === 'fridge2');
    }
    if (fridge === '3') {
      bestSellerText = t(`Locker Products`);
      result = products.filter((prod) => prod.prodType === 'linkedBox' && !prod.isSold);
    }
  }

  const products = result.map((prod, i) => {
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
    let url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.productPictures[0]}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;

    if (prod.prodType === 'fridge1' || prod.prodType === 'fridge2') {
      url = isLocal
        ? `${process.env.REACT_APP_LOCAL_API}/pictures/fridge/${prod.productPictures[0]}`
        : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
    } else if (prod.prodType === 'linkedBox') {
      url = isLocal
        ? `${process.env.REACT_APP_LOCAL_API}/pictures/linkedBoxProduct/${prod.productPictures[0]}`
        : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
    }

    return (
      <ProductCard
        remove={remove}
        langs={langs}
        mainL={mainL}
        symbol={symbol}
        setShowp={setShowp}
        cart={props.cart}
        alterquantity={props.alterquantity}
        add={props.add}
        decreStock={props.decreStock}
        prod={prod}
        image={url}
        key={i}
        twoLine={true}
        machineID={machineID}
      />
    );
  });

  let row1 = [];
  let row2 = [];

  if (
    (theme?.b_column === '1' && (theme?.c_column === '1' || theme?.c_column === '4')) ||
    fridge === '3'
  ) {
    row1 = products;
  } else {
    for (let i = 1; i <= products.length; i++) {
      if (i % 2 === 1) {
        row1.push(products[i - 1]);
      }
      if (i % 2 === 0) {
        row2.push(products[i - 1]);
      }
    }
  }

  // const goToALLProducts = () => {
  //   history.push(`/machineUI/category/cate/all/all`);
  // };

  return (
    <div className="homeProduct" style={{ marginBottom: '30px' }}>
      <h1 className="homeProductText"> {bestSellerText}</h1>
      {/* <div className="home-product-container d-flex">{products}</div> */}
      <div className="d-flex align-items-center">
        <div>
          <div style={{ width: '50px' }}>
            <ChevronLeftOutlinedIcon
              hidden={showL}
              className={arrayClassName('mr-2')}
              onClick={() => scroll(-100)}
            />
          </div>
        </div>
        <div className="home-product-container" ref={ref}>
          <div className="home-products-div">
            <div className="home-products">{row1}</div>
            {row2?.length > 0 && <div className="home-products mb-5">{row2}</div>}
          </div>
        </div>
        <div>
          <div style={{ width: '50px' }}>
            <ChevronRightOutlinedIcon
              hidden={showR}
              className={arrayClassName('ml-2')}
              onClick={() => scroll(100)}
            />
          </div>
        </div>
      </div>

      <div>
        {/* <div className="view-more-button" onClick={goToALLProducts}>
          {t('VIEW MORE')}
        </div> */}
      </div>
    </div>
  );
}
export default HomeProduct;
